import React, { Component } from 'react';
import { AggregatorConfigItems } from '../components/AggregatorConfigItems';
import { AggregatorConfigFields } from '../components/AggregatorConfigFields';
import { inject, observer } from 'mobx-react';
import { Button, FormControl, Glyphicon } from 'react-bootstrap';
import { required, isNumeric, isSingleChar, validateRuleMap } from '../utils/ValidatorRulesUtils';
import { Link } from 'react-router-dom';
import { toJS } from 'mobx';

@inject('configurationStore')
@observer
class AggregatorConfig extends Component {
  displayName = AggregatorConfig.name

  state = {
    currentTypeId: 0,
    selectedBranchId: "0"
  }

  componentDidMount() {
    const { customerId, configId } = this.props.match.params;
    this.props.configurationStore.setCurrentConfigId(parseInt(customerId, 10), parseInt(configId, 10));
    this.props.configurationStore.getNotificationChannels();
    this.props.configurationStore.getNotificationTypes();
    this.props.configurationStore.getBranches();
    this.props.configurationStore.getBranchItems(Number(customerId));
  }

  configRules = {
    friendlyName: [required],
    description: [required],
    adqRefId: [required, isNumeric],
    separator: [required, isSingleChar],
    channelId: [required]
  };

  itemRules = (isStaticProperty) => {
    return {
      propertyName: [required],
      propertyMappingValue: !isStaticProperty ? [required] : [],
      staticPropertyValue: isStaticProperty ? [] : []
    }
  };

  getHeaders = () => {
    const { config } = this.props.configurationStore;
    const headerString = config.configItems.filter(item => !item.isStaticProperty)
      .map(item => item.propertyMappingValue)
      .join(config.separator);

    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(headerString));
    element.setAttribute('download', config.description + '-headers.txt');

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  saveAllConfig = () => {
    const { configurationStore } = this.props;
    const { config } = configurationStore;
    const itemsAreValid = config.configItems.reduce((acc, item) => {
      const itemRules = this.itemRules(item.isStaticProperty);
      const isValid = validateRuleMap(itemRules, item);
      return acc && isValid;
    }, true);
    const configIsValid = validateRuleMap(this.configRules, config);
    if (itemsAreValid && configIsValid) {
      configurationStore.saveAllConfig();
      configurationStore.setAlert('Update completed successfully!', 'success')
    } else {
      configurationStore.setAlert('Some fields are invalid!', 'danger')
    }
  }

  setCurrentTypeId = (id) => {
    const { configurationStore } = this.props;
    const { config } = configurationStore;

    const currentType = configurationStore.getCurrentNotificationType(this.state.currentTypeId);

    if (currentType) {
      const fieldsArray = currentType.fields.map(type => type.name)

      config.configItems.forEach((item => {
        if (fieldsArray.indexOf(item.propertyName) > -1) {
          configurationStore.deleteConfigItem(item.propertyName);
        }
      }));
    }

    this.setState({ currentTypeId: id });
  }

  setBranchId = (event) => {
    this.setState({ selectedBranchId: event.target.value })

    this.props.configurationStore.getBranchItems(Number(this.props.match.params.configId), event.target.value);
  }

  createPropertyNames = () => {
    const { configurationStore } = this.props;
    const { config } = configurationStore;

    let propertyNamesBase = [
      '--Select--',
      'Version',
      'NotificationChannel',
      'FileId',
      'NotificationType',
      'NotificationCode',
      'CustomerCode',
      'CustomerName',
      'SenderName',
      'NotificationDescription',
      'ReplyTo',
      'From',
      'FromPhone',
      'RecipientId',
      'FirstName',
      'LastName',
      'FullName',
      'Email',
      'CopyEmails',
      'Phone',
      'AddressLine1',
      'AddressLine2',
      'CareOf',
      'City',
      'State',
      'Zip',
      'ReportingEmail',
      'BillingLocation',
      'NotificationSendAfterTime',
      'BranchRefId',
      'Subject',
      'PreHeader',
      'Wording1',
      'Wording2',
      'Wording3',
      'PlainTextOnly',
      'MediaUrls',
      'AttachmentIds'
    ];

    const currentType = configurationStore.getCurrentNotificationType(this.state.currentTypeId);

    if (currentType) {
      const fieldsArray = currentType.fields.map(type => type.name)
      propertyNamesBase.push(...fieldsArray);
    }

    const selectedProperties = config.configItems.map(item => item.propertyName);

    const propertyNames = propertyNamesBase.map(item => {
      const obj = { name: item, disabled: selectedProperties.find(x => x === item) ? true : false };
      return obj;
    });

    return propertyNames;
  }

  render() {
    const { configurationStore } = this.props;
    if (configurationStore.isLoading || configurationStore.config === void 0)
      return <p><em>Loading...</em></p>;

    const { customer, config, notificationChannels, notificationTypes, updateConfig,
      addCustomItem, addDefinedItem, hasBlankItem, updateConfigItem, deleteConfigItem,
      branches } = this.props.configurationStore;

    const propertyNames = this.createPropertyNames();
    const selectedProperties = config.configItems.filter(item => !item.isCustomProperty).map(item => item.propertyName);
    const customPropertyNames = config.configItems.filter(item => item.isCustomProperty).map(item => item.propertyName);

    return (
      <div>
        <h1>{`${customer.name} - ${config.friendlyName} - Config Id: ${config.id}`}</h1>
        <Link to={`/customer/${customer.id}`} className="mr-5">
          <Glyphicon glyph="arrow-left" /> All configs for {customer.name}
        </Link>
        <Button onClick={this.getHeaders}>Download Headers</Button>
        <hr></hr>
        <AggregatorConfigFields
          buttonText='Update'
          onSubmit={updateConfig}
          initialState={config}
          notificationChannels={notificationChannels}
          notificationTypes={notificationTypes}
          configurationStore={configurationStore}
          rules={this.configRules}
          setCurrentTypeId={this.setCurrentTypeId}

        />
        {
          branches.length > 0 ?
            <div style={{ marginTop: "20px", maxWidth: "300px" }}>
              <h5>Branch Overrides</h5>
              <FormControl componentClass="select" value={this.state.selectedBranchId} onChange={this.setBranchId}>
                <option value="0">All Branches</option>
                {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </FormControl>
            </div> : ''

        }
        {
          this.state.selectedBranchId == "0" ?
            <AggregatorConfigItems
              items={config.configItems}
              rules={this.itemRules}
              addCustomItem={addCustomItem}
              addDefinedItem={addDefinedItem}
              hasBlankItem={hasBlankItem}
              updateConfigItem={updateConfigItem}
              deleteConfigItem={deleteConfigItem}
              notificationTypes={notificationTypes}
              propertyNames={propertyNames}
              canEdit={true}
            /> :
            <AggregatorConfigBranchItems
              configurationStore={configurationStore}
              configId={Number(this.props.match.params.configId)}
              branchId={this.state.selectedBranchId}
              items={config.configItems}
              rules={this.itemRules}
              addCustomItem={addCustomItem}
              addDefinedItem={addDefinedItem}
              hasBlankItem={hasBlankItem}
              updateConfigItem={updateConfigItem}
              deleteConfigItem={deleteConfigItem}
              notificationTypes={notificationTypes}
              propertyNames={selectedProperties}
              customPropertyNames={customPropertyNames}
            />
        }
        <div>
          <Button disabled={this.state.selectedBranchId != '0'} bsStyle='success' bsSize='large' className='save-all' onClick={this.saveAllConfig}>Save All</Button>
        </div>
      </div>
    );
  }
}

export { AggregatorConfig };

const AggregatorConfigBranchItems = observer(({ configId, branchId, configurationStore, propertyNames, customPropertyNames, rules }) => {
  const selectedProperties = configurationStore.branchConfigItems.map(item => item.propertyName);
  const branchDefinedPropertyNames = ['--Select--'].concat(propertyNames).map(item => {
    const obj = { name: item, disabled: selectedProperties.find(x => x === item) ? true : false };
    return obj;
  });

  const branchCustomPropertyNames = ['--Select--'].concat(customPropertyNames).map(item => {
    const obj = { name: item, disabled: selectedProperties.find(x => x === item) ? true : false };
    return obj;
  });

  const addCustomItem = () => {
    configurationStore.addBranchConfigItem(configId, branchId, true)
  }

  const addDefinedItem = () => {
    configurationStore.addBranchConfigItem(configId, branchId, false)
  }

  const deleteConfigItem = (propertyName) => {
    configurationStore.deleteBranchConfigItem(configId, branchId, propertyName)
  }

  const saveAllItems = () => {
    const itemsAreValid = configurationStore.branchConfigItems.reduce((acc, item) => {
      const itemRules = rules(item.isStaticProperty);
      const isValid = validateRuleMap(itemRules, item);
      return acc && isValid;
    }, true);
    if (!itemsAreValid) {
      configurationStore.setAlert('Some fields are invalid!', 'danger')
    } else {
      configurationStore.saveAllBranchItems()
    }
  }

  return (
    <React.Fragment>
      <AggregatorConfigItems
        items={configurationStore.branchConfigItems}
        rules={rules}
        addCustomItem={addCustomItem}
        addDefinedItem={addDefinedItem}
        hasBlankItem={configurationStore.hasBlankBranchItem}
        updateConfigItem={configurationStore.updateBranchConfigItem}
        deleteConfigItem={deleteConfigItem}
        propertyNames={branchDefinedPropertyNames}
        customPropertyNames={branchCustomPropertyNames}
        canEdit={false}
      />
      <Button style={{ marginTop: "50px" }} bsStyle='success' className='save-branch-items' onClick={saveAllItems}>Save Branch Items</Button>
    </React.Fragment>
  )
})